import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

export const getAsyncRequestForActiveComponentDesign = createSelector(
  (state: RootState) => state.selections.activeComponentDesignGuid,
  (state: RootState) => state.asyncRequests,
  (activeComponentDesignGuid, asyncRequests) => activeComponentDesignGuid && asyncRequests[activeComponentDesignGuid],
);
